import { render, staticRenderFns } from "./DelegationsInfo.vue?vue&type=template&id=00deb558&"
import script from "./DelegationsInfo.vue?vue&type=script&lang=js&"
export * from "./DelegationsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DelegationsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports